export default __webpack_public_path__ + "static/media/nfcc-logo.dde853af.png";